/**
 *   Author - Tobias Wild
 */
(function ($) {
    $.fn.extend({
        // very simple tab navigation
        simpleTabs: function () {
            return this.each(function () {
                var $elm = $(this);

                var $tabs = $elm.find('ul.tab-navigation li');

                $elm.on('change.tabs', function () {
                    var pos = $tabs.index($tabs.filter('.active'));
                    var $contents = $elm.find('div.tab-content > div');

                    $contents.hide();
                    $contents.eq(pos).show();
                });

                $tabs.on('click', function (e) {
                    e.preventDefault();

                    $tabs.removeClass('active');
                    $(this).addClass('active');

                    $elm.trigger('change.tabs');
                });
            });
        }
    });
})(jQuery);